// extracted by mini-css-extract-plugin
export default {"webinar":"Webinar_webinar__ipwIF","eventDetailsWrapper":"Webinar_eventDetailsWrapper__fSYfc"};